import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-t border-primary/20 bg-background py-16 sm:py-20" aria-labelledby="results-title" data-id="element-125" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="2d79avywsrafk">
        <SectionHeading id="results-title" data-id="element-127" data-mp="2h81m2xp8bpeh">What <span className="text-primary" data-id="element-128" data-mp="2h70a8r0e2yvp">professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-129" data-mp="2m5lc0uvahqm9">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-primary/30 bg-surface p-6 shadow-glow" data-id="element-130" data-mp="2r6913azyjxdu" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-primary" aria-hidden="true" data-id="element-131" data-mp="3neqz57s78ftr" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-132" data-mp="3ilxv6m4k1biq">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/20 pt-4" data-id="element-133" data-mp="3do60jkcizbau">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/50 bg-background text-sm font-extrabold text-primary" data-id="element-134" data-mp="38q4k776hhq32">
                  {initials}
                </span>
                <span data-id="element-135" data-mp="55qch5vazkbk">
                  <b className="block text-sm text-foreground" data-id="element-136" data-mp="8gh79l8geft">{name}</b>
                  <small className="text-xs text-muted/80" data-id="element-137" data-mp="at6k7tblr2w">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}